<template>
	<v-container fluid>
	  <v-row>

    	<v-col cols="12">
        <v-text-field
          v-model="editedItem.grupo"
          label="* Grupo"
          filled
          hide-details
          dense
          readonly
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="planteles"
          v-model="editedItem.id_plantel"
          label="Plantel"
          outlined
          hide-details
          dense
          item-text="plantel"
          item-value="id_plantel"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="filterCursos"
          v-model="editedItem.id_curso"
          label="Curso"
          outlined
          hide-details
          dense
          item-text="curso"
          item-value="id_curso"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="ciclos"
          v-model="editedItem.id_ciclo"
          label="Ciclo"
          outlined
          hide-details
          dense
          item-text="ciclo"
          item-value="id_ciclo"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="horarios"
          v-model="editedItem.id_horario"
          label="Horario"
          outlined
          hide-details
          dense
          item-text="horario"
          item-value="id_horario"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="filterSalones"
          v-model="editedItem.id_salon"
          label="Salon"
          outlined
          hide-details
          dense
          item-text="salon_label"
          item-value="id_salon"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-autocomplete
        	:items="niveles"
          v-model="editedItem.id_nivel"
          label="Nivel"
          outlined
          hide-details
          dense
          item-text="nivel"
          item-value="id_nivel"
        ></v-autocomplete>
      </v-col>

      <!-- <v-col cols="12" md="6">
        <v-text-field
          v-model="editedItem.cupo"
          label="Cupo"
          filled
          hide-details
          dense
        ></v-text-field>
      </v-col> -->

      <!-- <v-col cols="12" md="6">
        <v-text-field
          v-model="editedItem.precio"
          label="* precio"
          filled
          hide-details
          dense
          readonly
        ></v-text-field>
      </v-col> -->

      <v-col cols="12" sm="6" class="pt-0">
      	<v-switch 
      		label="¿Activo Si/No?"
          hide-details
          v-if="editedItem.alumnos == 0"
      		v-model="editedItem.activo_sn">
      	</v-switch>
      </v-col>

      <v-col cols="12" sm="6" class="pt-0">
      	<div class="text-subtitle-1"><b>Fecha alta:</b> {{ editedItem.fecha_alta }}</div>
      	<div class="text-subtitle-1"><b>Fecha baja:</b> {{ editedItem.fecha_baja }}</div>
      </v-col>

      <v-col cols="12" align="right">
        <v-btn color="primary" @click="save">Guardar</v-btn>
      </v-col>
    </v-row>

	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
  import salonesDisponibles from '@/mixins/salonesDisponibles'
	// Componentes
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

	// Componentes
  export default {

  	mixins: [ salonesDisponibles ],

  	components:{
      Alerta,
      carga,
    },

  	props:[
			'editedItem',
			'gruposOcupacion',
			'horariosCatalog'
	  ],
    data: () => ({

      // tabla
      teachers:[],
      teacher1: null,
      teacher2: null,

      // Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      ciclos:[],
			salones:[],
			cursos:[],
			planteles:[],
			horarios:[],
			niveles:[],

			editar: false,

			plantel:'',
			ciclo:'',
			curso:'',
			horario:'',
			nivel:'',
			salon:'',
      gruposCicloOcupacion: [],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

      filterCursos( ){

        if( this.plantel ){
          
          if( this.plantel.match('ONLINE')){
            
            return this.cursos.filter( el => el.curso.match('ONLINE') || el.curso.match('CAMBIO') || el.curso.match('EXCI') )

          }else{
            
            return this.cursos.filter( el => !el.curso.match('ONLINE') )

          }


        }else{
          return []
        }

      },

      gruposParaOcupacion () {
        const porCiclo = this.gruposCicloOcupacion || []
        if (porCiclo.length) return porCiclo
        return this.gruposOcupacion || []
      },

      filterSalones () {
        const catalog = this.horariosCatalog || this.horarios || []
        const h = catalog.find(x => x.id_horario == this.editedItem.id_horario)
        // Enriquecer con horas del catálogo: editedItem a veces solo trae id_horario
        const grupoRef = h
          ? {
            ...this.editedItem,
            hora_inicio: this.editedItem.hora_inicio || h.hora_inicio,
            hora_fin: this.editedItem.hora_fin || h.hora_fin
          }
          : this.editedItem

        return this.filterSalonesDisponibles({
          salones: this.salones,
          idPlantel: this.editedItem.id_plantel,
          idCiclo: this.editedItem.id_ciclo,
          idHorario: this.editedItem.id_horario,
          idSalonActual: this.editedItem.id_salon,
          grupos: this.gruposParaOcupacion,
          excludeGrupoId: this.editedItem.id_grupo,
          horariosCatalog: catalog,
          grupoRef,
          soloDisponibles: true
        })
      }

    },

    watch: {

    	'editedItem.id_plantel'( val ){
    		const existe = this.planteles.find( el=> el.id_plantel == val )
    		this.plantel = existe ? existe.plantel.trim() : ''
        this.editedItem.plantel = this.plantel
        this.editedItem.grupo = `${this.editedItem.plantel} - ${this.editedItem.ciclo} - ${this.editedItem.horario} - ${this.editedItem.nivel}`
        this.cargarGruposOcupacion()
        this.limpiarSalonSiOcupado()
    	},

    	'editedItem.id_ciclo'( val ){
    		const existe = this.ciclos.find( el=> el.id_ciclo == val )
    		this.ciclo = existe ? existe.ciclo.trim() : ''
        this.editedItem.ciclo = this.ciclo
        this.editedItem.grupo = `${this.editedItem.plantel} - ${this.editedItem.ciclo} - ${this.editedItem.horario} - ${this.editedItem.nivel}`
        this.cargarGruposOcupacion()
        this.limpiarSalonSiOcupado()
    	},

    	'editedItem.id_horario'( val ){
    		const existe = this.horarios.find( el=> el.id_horario == val )
    		this.horario = existe ? existe.horario.trim() : ''
        this.editedItem.horario = this.horario
        this.editedItem.grupo = `${this.editedItem.plantel} - ${this.editedItem.ciclo} - ${this.editedItem.horario} - ${this.editedItem.nivel}`
        this.limpiarSalonSiOcupado()
    	},

    	'editedItem.id_nivel'( val ){
    		const existe = this.niveles.find( el=> el.id_nivel == val )
    		this.nivel = existe ? existe.nivel.trim() : ''
        this.editedItem.nivel = this.nivel
        this.editedItem.grupo = `${this.editedItem.plantel} - ${this.editedItem.ciclo} - ${this.editedItem.horario} - ${this.editedItem.nivel}`
    	},

    	'editedItem.id_curso'( val ){
    		const existe = this.cursos.find( el=> el.id_curso == val )
    		this.curso = existe ? existe.curso.trim() : ''
    		this.editedItem.precio = existe ? existe.precio_nivel : 'NO EXISTE PRECIO'
    	}

    },

    async created () {
    	this.editar =  this.editedItem.id_grupo ? true : false
      await this.getCiclos()
      await this.getSalones()
      await this.getCursos()
      await this.getPlanteles()
      await this.getHorarios()
      await this.getNiveles()
      if (this.editedItem.plantel) {
        this.plantel = String(this.editedItem.plantel).trim()
      } else if (this.editedItem.id_plantel) {
        const existe = this.planteles.find(el => el.id_plantel == this.editedItem.id_plantel)
        this.plantel = existe ? existe.plantel.trim() : ''
      }
      await this.cargarGruposOcupacion()
    },

    methods: {
      escuelaOcupacion () {
        const nombre = String(this.plantel || this.editedItem.plantel || '').toUpperCase()
        return nombre.indexOf('FAST') >= 0 ? 1 : 0
      },

      cargarGruposOcupacion () {
        const idCiclo = this.editedItem && this.editedItem.id_ciclo
        if (!idCiclo) {
          this.gruposCicloOcupacion = []
          return Promise.resolve()
        }
        return this.$http.post('grupos.list', {
          id_ciclo: idCiclo,
          escuela: this.escuelaOcupacion()
        }).then(response => {
          this.gruposCicloOcupacion = response.data || []
          this.limpiarSalonSiOcupado()
        }).catch(() => {
          this.gruposCicloOcupacion = this.gruposOcupacion || []
        })
      },

      limpiarSalonSiOcupado () {
        const idSalon = this.editedItem && this.editedItem.id_salon
        if (!idSalon) return
        const ok = (this.filterSalones || []).some(s => s.id_salon == idSalon)
        if (!ok) this.editedItem.id_salon = null
      },

      salonDisponibleParaGuardar () {
        if (!this.editedItem.id_salon) return false
        if (!this.editedItem.id_ciclo || !this.editedItem.id_horario || !this.editedItem.id_plantel) return true
        return (this.filterSalones || []).some(s => s.id_salon == this.editedItem.id_salon && s.disponible !== false)
      },

    	save () {

        this.editar =  this.editedItem.id_grupo ? true : false

        if (!this.salonDisponibleParaGuardar()) {
          this.validarErrorDirecto('Ese salón ya está ocupado en el mismo ciclo y horario. Elige otro para no empalmar grupos.')
          return
        }
        
    		if( this.editar ){
	      	// Cargamos al usuario que hizo el cambio
	      	this.editedItem['id_usuario'] = this.getdatosUsuarioERPERP.iderp
		      this.cargar = true
	        // Lo mandapos por el EP
	        this.$http.put('grupos.update/' + this.editedItem.id_grupo, this.editedItem).then(response=>{
	        	this.validarSuccess( response.data.message )
	        	this.$emit('click')
	        	this.initialize()
	        }).catch( error =>{
	        	this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })
    		}else{
    			// Cargamos al usuario que hizo el cambio
	      	this.editedItem['id_usuario']  = this.getdatosUsuarioERPERP.iderp
	      	this.editedItem['disponibles'] = this.editedItem.cupo
		      this.cargar = true
	        // Lo mandapos por el EP
	        this.$http.post('grupos.add', this.editedItem).then(response=>{
	        	this.validarSuccess( response.data.message )
	        	this.$emit('click')
	        	this.initialize()
	        }).catch( error =>{
	        	this.validarError( error.response.data.message )
	        }).finally( () => { this.cargar = false })
    		}
      },

      getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getSalones () {
      	this.cargar = true
        this.salones = []
        return this.$http.get('salones.activos').then(response=>{
        	this.salones = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getCursos () {
      	this.cargar = true
        this.cursos = []
        return this.$http.get('cursoserp.activos').then(response=>{
        	this.cursos = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getPlanteles () {
      	this.cargar = true
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getHorarios () {
      	this.cargar = true
        this.horarios = []
        return this.$http.get('horarios.activos').then(response=>{
        	this.horarios = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getNiveles () {
      	this.cargar = true
        this.niveles = []
        return this.$http.get('niveles.activos').then(response=>{
        	this.niveles = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      validarSuccess( mensaje ){
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = 'success'
        this.respuestaAlerta         = true 
      },

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

      validarErrorDirecto ( mensaje ) {
        this.cargar = false 
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = '#FF2C2C'
        this.respuestaAlerta = true 
    	},
    },
  }
</script>


